import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteClient($companyId: ID!, $id: ID!) {
    deleteClient(companyId: $companyId, id: $id) {
      client {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
